// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  dialogContainer: {
    padding: theme.spacing(4),
    width: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  dialogContainerWithData: {
    height: '80vh',
    maxHeight: '600px',
  },
  dialogContainerTitle: {
    fontWeight: '600',
  },
  dialogInputs: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 2,
    marginBottom: theme.spacing(2),
  },
  inputWidth: {
    width: '50%',
  },
  deliverablesContainer: {
    height: 'auto',
    maxHeight: '300px',
    overflowY: 'auto',
    marginBottom: theme.spacing(2),
  },
  // The parent's layers are loading: a spinner in their place, and nothing else
  layersLoading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  subtypeName: {
    fontWeight: '600',
  },
  subtypeContainer: {
    marginBottom: theme.spacing(2),
  },
  checked: {
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 2,
  },
  buttonContainerWithAttributes: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 2,
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  pointsAndAttributesContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  outputText: {
    textAlign: 'center',
  },
  pointsToggle: {
    display: 'flex',
    justifyContent: 'center',
    marginLeft: theme.spacing(1),
  },
  closeButton: {
    color: '#021E40',
    opacity: '50%',
    fontSize: theme.spacing(2),
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
  },
  selected: {
    fontSize: '0.65rem',
    padding: '4px 8px',
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },
  notSelected: {
    fontSize: '0.65rem',
    padding: '4px 8px',
  },
});

export default styles;
